var _style, _line, _polyline, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 336 64",
    style: {
      enableBackground: "new 0 0 336 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.line{fill:none;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "line",
    x1: -0.1,
    y1: 32,
    x2: 305,
    y2: 32
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "299.9,26.5 305.4,32 299.9,37.5 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 32,
    r: 30.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.3,7.3c0,0-4.8-0.6-6.8-0.6c-3.4,0-5.2,1.2-5.2,3.9c0,3.1,1.7,3.6,5.8,4.6c4.8,1.1,6.9,2.2,6.9,6.4 c0,5.3-2.9,7.4-7.6,7.4c-2.8,0-7.6-0.8-7.6-0.8L5.1,26c0,0,4.7,0.6,7.1,0.6c3.4,0,5.1-1.5,5.1-4.8c0-2.7-1.4-3.5-5.3-4.2 c-4.9-1.1-7.4-2.2-7.4-6.8c0-4.6,3-6.4,7.7-6.4c2.8,0,7.2,0.7,7.2,0.7L19.3,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2,4.7h17.3v2.4h-7.3v21.5h-2.6V7.1h-7.4V4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,4.7h5.8L58,28.6h-2.6l-1.7-6.1H43.4l-1.7,6.1h-2.6L45.6,4.7z M44,20.1h9L49.4,7h-1.8L44,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,19.5v9.2h-2.7V4.7h8.8c5,0,7.6,2.2,7.6,7.3c0,3.5-1.4,6-4.4,6.9l4.6,9.7h-2.9l-4.3-9.2H64.4z M70.6,7.1h-6.2v10h6.2 c3.6,0,4.9-2.1,4.9-5.1C75.5,8.7,74,7.1,70.6,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2,4.7h17.3v2.4h-7.3v21.5h-2.6V7.1h-7.4V4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,4.7h17.3v2.4H116v21.5h-2.6V7.1H106V4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3,19.5v9.2h-2.7V4.7h8.8c5,0,7.6,2.2,7.6,7.3c0,3.5-1.4,6-4.4,6.9l4.6,9.7h-2.9l-4.3-9.2H129.3z M135.5,7.1h-6.2v10 h6.2c3.6,0,4.9-2.1,4.9-5.1C140.4,8.7,138.8,7.1,135.5,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1,4.7h5.8l6.6,23.9h-2.6l-1.7-6.1h-10.2l-1.7,6.1h-2.6L152.1,4.7z M150.5,20.1h9L155.9,7h-1.8L150.5,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2,4.7h2.7v23.9h-2.7V4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,4.7h5l9.2,21.5h0.7V4.7h2.6v23.9h-4.9l-9.3-21.5h-0.7v21.5h-2.7V4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,4.7h2.7v23.9h-2.7V4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.6,4.7h5l9.2,21.5h0.7V4.7h2.6v23.9h-4.9l-9.3-21.5h-0.7v21.5h-2.7V4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.4,16.4h6.6v11.7c-0.7,0.1-5.1,0.8-7.8,0.8c-7.3,0-9.3-4.5-9.3-12.2c0-7.9,2-12.4,9.2-12.4c3.6,0,7.8,0.9,7.8,0.9 l-0.1,2.2c0,0-4.3-0.7-7.4-0.7c-5.5,0-6.7,3.2-6.7,10c0,6.6,1.2,9.9,6.7,9.9c1.7,0,4-0.3,4.9-0.5v-7.4h-4V16.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.51f351d0.svg";
export { ForwardRef as ReactComponent };